// Auto-generated skeleton for Sync

export const Sync: Api.Sync = {
  id: 0,
  started_at: '',
  grouped_count: 0,
  total_count: 0,
  ended_at: null,
  version: null,
  created: null,
  updated: null,
};

